////////////////////////
// M028 downloads

function initDownloads() {
    if ($(".downloadList--hidable").length > 0) {

        $(".downloadList--hidable").each(function () {
            $(this).find(".downloadList__header").on("click", function (e) {
                $(this).closest(".downloadList").toggleClass("opened");
            });
            $(this).find(".downloadList__header").on("keydown", handleKeyDownForClick);
        });

    }
}
